<template>
  <div>
      <div class="news-list">
        <b-container>
          <div class="row">
            <div
              class="col-12 col-sm-6 col-md-4"
              v-for="(item, index) in $t(newslistname)"
              v-bind:key="index"
            >
              <!-- {{JSON.stringify(productlist[index][index2])}} -->
              <div class="news-item" @click="viewnews(item)">
                <b-img
                  :src="item.newsimg"
                  fluid
                  alt="宁波天鑫仪表有限公司"
                ></b-img>
                <div class="news-body">
                  <div class="product-item-body-head row">
                    <div class="product-item-type">
                      {{ $t("titlelist")[item.newstype] }}
                    </div>
                    <div class="product-item-date">{{ item.newsdate }}</div>
                  </div>
                  <div class="news-item-title">
                    {{ item.newstitle }}
                  </div>
                  <div class="news-item-info">
                    <span>{{ item.newsinfo }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-pagination
            class="news-pagination"
            align="center"
            v-model="page"
            :total-rows="rows"
            :per-page="limit"
            first-number
            last-number
          >
            <template #prev-text><span class="pagestyle">&lt;</span></template>
            <template #next-text><span class="pagestyle">&gt;</span></template>
          </b-pagination>
        </b-container>
      </div>
  </div>
</template>
<script>
import Sticky from "sticky-js";
export default {
  props: {
    active: {
      type: Number,
    },
  },
  watch: {
    page(to) {
      this.page = to;
      this.getNewsDetail();
    },
  },
  data() {
    return {
      isRouterAlive: true,

      limit: 12,
      page: 1,
      type: 0,

      newslist: [],
      rows: 0,
      newslistname: "",
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    getNewsDetail() {
      const _this = this;
    //   this.isRouterAlive = false;
      this.$store
        .dispatch("getNewsDetail", {
          limit: _this.limit,
          page: _this.page,
          type: _this.active,
        })
        .then((data) => {
          _this.rows = data.total;
          let zh = [];
          let en = [];
          data.list.forEach((element) => {
            zh.push({
              newsid: element.id,
              newstitle: element.title,
              newsimg: element.img,
              newsdate: element.effect_at,
              newspage: element.page,
              newstype: element.type,
              newsinfo: element.desc,
            });
            en.push({
              newsid: element.id,
              newstitle: element.title_en,
              newsimg: element.img,
              newsdate: element.effect_at,
              newstype: element.type,
              newspage: element.page_en,
              newsinfo: element.desc_en,
            });
          });
          _this.newslistname = `newslist${new Date().getTime()}`;
          let enObj = {};
          let zhObj = {};
          enObj[_this.newslistname] = en;
          zhObj[_this.newslistname] = zh;
          _this.$i18n.mergeLocaleMessage("en", enObj);
          _this.$i18n.mergeLocaleMessage("zh", zhObj);

          let lang = _this.$i18n.locale;
          _this.$i18n.locale = lang;
          _this.reload();
          const sticky2 = new Sticky(".sticky2");
          sticky2.update();
        });
    },
    viewnews(item) {
      this.$router.push({
        path: "/newsdetail",
        query: {
          id: item.newsid,
        },
      });
    },
  },
  mounted() {
    this.getNewsDetail();
  },
};
</script>

<style>
.news-list {
  padding-bottom: 100px;
}
.page-item.active .page-link {
  color: #c00f31;
  background-color: #ffffff00;
}
.page-link {
  color: #000;
  border: 0;
}
.page-link:hover {
  color: #c00f31;
}
.pagestyle {
  color: #000;
  padding: 6px 10px;
  border: 0.5px #bdbdbd88 solid;
}
.pagestyle:hover {
  background-color: #00000000;
  color: #c00f31;
}
.news-pagination button:hover {
  background-color: #00000000;
}
.page-item:hover {
  background-color: #00000000;
}
.news-pagination {
  margin-top: 100px;
}
.news-item {
  margin-top: 30px;
  cursor: pointer;
}

.news-item:hover {
  -webkit-box-shadow: #00000034 0px 0px 10px;
  -moz-box-shadow: #00000034 0px 0px 10px;
  box-shadow: #00000034 0px 0px 10px;
}
.news-body {
  padding: 10px 30px 20px 30px;
  background-color: #ededed;
}
.product-item-body-head {
  font-size: 12px;
}
.product-item-date {
  font-size: 12px;
  font-weight: 200;
  color: #8a8a8a;
  margin-left: 10px;
}
.product-item-type {
  background-color: #c00f31;
  color: #ffffff;
  padding: 0 5px;
  margin-left: 15px;
}
.news-item-title {
  /* white-space: nowrap; */
  font-weight: bold;
  font-size: 16px;
  color: #000;
       overflow:hidden;
text-overflow:ellipsis;
white-space:nowrap;
}
.news-item-info {
  margin-top: 30px;
  font-size: 12px;
  height: 50px;
  color: #8a8a8a;overflow:hidden;

text-overflow:ellipsis;

display:-webkit-box;

-webkit-line-clamp:2;

-webkit-box-orient:vertical;
}
</style>
